import { Enum } from 'enumify'

class SupportedAmenities extends Enum {}

export default SupportedAmenities.initEnum([
  'CARRY_ON',
  'CHECKED_BAG',
  'MEALS',
  'SEATS',
  'WIFI',
  'REBOOKING',
  'REFUND',
])
